import {
  type RecentlyVisitedPage,
  useRecentlyVisited,
} from "@src/appV2/lib/utils/useRecentlyVisited";
import { NavigationMenuItemTablet } from "@src/appV2/redesign/AppLayout/Desktop/Tablet/Navigation/MenuItem";
import { RecentlyViewedDialog } from "@src/appV2/redesign/AppLayout/Desktop/RecentlyViewedDialog";
import { useModalState } from "@src/lib/ui-react";

import { useAccountSwitcher } from "../../Shared/AccountSwitcher/useAccountSwitcher";

interface RecentlyViewedSectionTabletProps {
  admin: boolean;
}

export function RecentlyViewedSectionTablet(props: RecentlyViewedSectionTabletProps) {
  const { admin } = props;

  const [recentVisited] = useRecentlyVisited();
  const { onUserClicked } = useAccountSwitcher();
  const recentlyViewedDialogState = useModalState();

  if (!admin) {
    return null;
  }

  if (!recentVisited || recentVisited.length === 0) {
    return null;
  }

  return (
    <>
      <NavigationMenuItemTablet
        iconType="clock-back"
        isSelected={false}
        onClick={recentlyViewedDialogState.openModal}
      >
        Recently Viewed
      </NavigationMenuItemTablet>
      <RecentlyViewedDialog
        modalState={recentlyViewedDialogState}
        recentVisited={recentVisited}
        onUserClicked={(item: RecentlyVisitedPage) => {
          onUserClicked({
            userId: item.id,
            name: item.title,
            title: item.title,
            type: item.type as "AGENT" | "WORKPLACE",
          });
        }}
      />
    </>
  );
}
